import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Toggle from "./context/Toggle";
import { HashRouter } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HashRouter>
      <Toggle>
        <App />
      </Toggle>
    </HashRouter>
  </React.StrictMode>
);
